/* eslint-disable import/no-extraneous-dependencies */
import { createAction } from 'redux-actions';

export const getScheduleBookStatisticRequest = createAction('GET_SCHEDULE_BOOK_STATISTIC_REQUEST');
export const getScheduleBookStatisticSuccess = createAction('GET_SCHEDULE_BOOK_STATISTIC_SUCCESS');
export const getScheduleBookStatisticFailure = createAction('GET_SCHEDULE_BOOK_STATISTIC_FAILURE');
